import Decimal from "decimal.js";
import { Amount } from "types/amount";
import { Text } from "components/general/Text";
import { GlobalStore } from "store/global/GlobalStore";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { SerializedStyles } from "@emotion/react";
import { Hash } from "viem";

interface AmountAndUsdPriceFullWidthProps {
  tokenAddress: Hash;
  amount: Amount;
  usdValue: Decimal;
  isAmountShown: boolean;
  dimAmountValues?: boolean;
  css?: SerializedStyles;
}

export const AmountAndUsdPriceFullWidth = ({
  tokenAddress,
  amount,
  usdValue,
  isAmountShown,
  dimAmountValues,
  css,
}: AmountAndUsdPriceFullWidthProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const tokenList = useTokenListByChain();

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        width: "100%",
        gap: 10,
        top: -8,
        opacity: dimAmountValues ? 0.5 : 1,
      }}
    >
      {amount.value.gt(0) && usdValue.gt(0) && (
        <>
          <div style={{ width: "50%", textAlign: "end" }}>
            {isAmountShown && (
              <Text textStyle="Paragraph" size="Large" css={css} color={theme.font.primary.default}>
                {amount.toDisplay(tokenAddress, tokenList)}
              </Text>
            )}
          </div>
          <div style={{ width: "50%" }}>
            <Text textStyle="Paragraph" size="Large" css={css} color={theme.font.secondary.default}>
              $
              {Intl.NumberFormat(navigator.language, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }).format(usdValue.toNumber())}
            </Text>
          </div>
        </>
      )}
    </div>
  );
};
